"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _invariant = _interopRequireDefault(require("invariant"));

var _notExitstsToQuery = _interopRequireDefault(require("./toQueryHelpers/notExitstsToQuery"));

var _equalToQuery = _interopRequireDefault(require("./toQueryHelpers/equalToQuery"));

var _inToQuery = _interopRequireDefault(require("./toQueryHelpers/inToQuery"));

var convertToQuery = function convertToQuery(filterField) {
  var _ref = typeof filterField === 'function' ? {
    toQuery: filterField
  } : filterField,
      field = _ref.field,
      toQuery = _ref.toQuery,
      value = _ref.value;

  if (toQuery) return toQuery(value, field);
  (0, _invariant.default)(field, "'convertToQuery' required at least 'field' prop.");
  if (value === undefined) return (0, _notExitstsToQuery.default)(field);
  if (Array.isArray(value)) return (0, _inToQuery.default)(field, value);
  return (0, _equalToQuery.default)(field, value);
};
/**
 * Prevede `filterField` na `queryField`.
 *
 * Pokud existuje filterField a ma funkci `toQuery` pro konverzi bude pouzita tato funkce.
 * V opacnem pripade bude `field` a `value` prevedena na `queryField` pomoci helperu:
 * 1. `value` je undefined `notExistsToQuery`
 * 2. `value` neni `Array` a neni undefined: `equalToQuery`
 * 3. `value` je `Array` a neni undefined `inToQuery`
 *
 * @param {Function | { field: string, value: *, toQuery?: (value, fieldName) => void }} filterField
 *
 * @returns {void | Object}
 */


var mapFilterFieldsToQuery = function mapFilterFieldsToQuery(filterField) {
  return filterField ? convertToQuery(filterField) : undefined;
};

var _default = mapFilterFieldsToQuery;
exports.default = _default;